export default __webpack_public_path__ + "static/media/arrow-up.f189d2e1.svg";